import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { ListType } from '../../../../../sic-lib/types/Lists';
import { MenuContactActionDialogs } from '../MenuTableContactActions';

type Props = {
    listType: ListType;
    anchorEl: HTMLElement | null;
    menuId: string;
    onOpenDialogHandler: (event: React.MouseEvent<HTMLElement>) => void;
    onCloseHandler: () => void;
    listId: number;
};

export default function MenuTableContactActionsRaw({
    listType,
    anchorEl,
    menuId,
    onOpenDialogHandler,
    onCloseHandler,
    listId,
}: Props) {
    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            <MenuItem
                data-dialog-id={MenuContactActionDialogs.addGroup}
                onClick={onOpenDialogHandler}
            >
                Add To Group
            </MenuItem>
            {listType === ListType.static && listId > -2 && (
                <MenuItem
                    data-dialog-id={MenuContactActionDialogs.removeGroup}
                    onClick={onOpenDialogHandler}
                >
                    Remove From Group
                </MenuItem>
            )}
            <Divider />
            <MenuItem
                data-dialog-id={MenuContactActionDialogs.editContact}
                onClick={onOpenDialogHandler}
            >
                Contact Info
            </MenuItem>
            <MenuItem
                data-dialog-id={MenuContactActionDialogs.deleteContact}
                onClick={onOpenDialogHandler}
            >
                Delete Contact
            </MenuItem>
        </Menu>
    );
}
